import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: require("./locales/en.json"),
    },
    fr: {
      translation: require("./locales/fr.json"),
    },
  },
  fallbackLng: "en", // Default language
  interpolation: {
    escapeValue: false, // React handles this
  },
});

export default i18n;
